module.exports = __webpack_public_path__ + "static/media/icon_conforms.964b8f74.svg";